<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember class="mb-0 mb-sm-3" />
        </b-col>
      </b-row>
    </b-container>
    <b-container class="px-0 px-sm-3">
      <b-card
        header-bg-variant="dark"
        header-border-variant="dark"
        header-text-variant="white"
        header-tag="header"
        border-variant="dark"
        class="main-card"
      >
        <template #header class="card-header px-0">
          <router-link to="/">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </template>
        <b-row>
          <b-col>
            <h5>
              <i class="fas fa-donate"></i> แจ้งเติมเครดิต
            </h5>
          </b-col>
        </b-row>
        <div class="w-100 mt-2 mb-3 border-bottom"></div>
        <b-row align-h="center">
          <b-col cols="12" md="8" lg="6">
            <b-card>
              <h5>
                <b-badge pill variant="success" class="mr-2">Step 1</b-badge>
                <span class="text-secondary">บัญชีธนาคาร {{getAppName}}</span>
              </h5>
              <label id="labelselectbank" v-if="!transfered">
                <i class="fas fa-university"></i>
                เลือกบัญชีธนาคารของเว็บ
              </label>
              <label id="labelselectbank" v-if="transfered">
                <i class="fas fa-university"></i>
                บัญชีของเว็บที่ท่านโอนเงินเข้า
              </label>
              <div v-if="!transfered">
                <v-select
                  :options="systemBanks"
                  v-model="systemBankSelected"
                  placeholder="กรุณาเลือกธนาคาร"
                  @change="selectBank"
                >
                  <template v-slot:selected-option="option">
                    <b-img
                      :src="banks[banks.map(e => e.bankID).indexOf(option.bankID)].logo"
                      height="22"
                      width="22"
                      class="mr-2 bank-icon"
                      :style="'background-color: ' + banks[banks.map(e => e.bankID).indexOf(option.bankID)].color"
                    />
                    <b-badge variant="light" class="mr-2">{{banks[banks.map(e => e.bankID).indexOf(option.bankID)].code}}</b-badge>
                    {{ banks[banks.map(e => e.bankID).indexOf(option.bankID)].title }}
                  </template>
                  <template v-slot:option="option">
                    <b-img
                      :src="banks[banks.map(e => e.bankID).indexOf(option.bankID)].logo"
                      height="22"
                      width="22"
                      class="mr-2 bank-icon"
                      :style="'background-color: ' + banks[banks.map(e => e.bankID).indexOf(option.bankID)].color"
                    />
                    <b-badge variant="light" class="mr-2">{{banks[banks.map(e => e.bankID).indexOf(option.bankID)].title}}</b-badge>
                    {{ banks[banks.map(e => e.bankID).indexOf(option.bankID)].title }}
                  </template>
                </v-select>
              </div>

              <b-card bg-variant="light" class="mt-3" v-if="systemBankSelected.length == 0">
                <div class="row justify-content-center">
                  <div class="col-12 col-sm-12 col-md-5 col-lg-4 text-center text-md-left">
                    <img
                      :src="require('../../assets/images/bank-icon.png')"
                      alt
                      height="115"
                      width="115"
                      class="bank-logo detail-bank table-secondary rounded"
                    />
                  </div>
                  <div
                    class="col-12 col-sm-12 col-md-7 col-lg-6 text-center text-md-left p-2 d-flex flex-column justify-content-center align-items-start"
                  >
                    <h6 class="font-weight-bold mb-0 w-100">
                      กรุณาเลือก บัญชีธนาคาร
                      <br />ของเว็บ {{getAppName}}
                    </h6>
                  </div>
                </div>
              </b-card>

              <b-card bg-variant="light" class="mt-3" v-else>
                <div class="row justify-content-center">
                  <div class="col-12 col-sm-12 col-md-5 col-lg-4 text-center">
                    <b-img
                      :src="banks[banks.map(e => e.bankID).indexOf(systemBankSelected.bankID)].logo"
                      height="115"
                      width="115"
                      class="bank-logo"
                      :style="'background-color: ' + banks[banks.map(e => e.bankID).indexOf(systemBankSelected.bankID)].color"
                      rounded
                    />
                  </div>
                  <div
                    class="col-12 col-sm-12 col-md-7 col-lg-6 p-2 pl-3 d-flex flex-column justify-content-center align-items-center text-sm-center text-md-left"
                  >
                    <h5
                      class="font-weight-bold mb-0"
                      :style="'color: ' + banks[banks.map(e => e.bankID).indexOf(systemBankSelected.bankID)].logo + ' !important;'"
                    >{{systemBankSelected.accountNo}}</h5>
                    <b-badge variant="secondary" pill>ชื่อบัญชี</b-badge>
                    <div>{{systemBankSelected.accountName}}</div>
                    <b-btn
                      type="button"
                      size="sm"
                      class="mt-1"
                      variant="outline-secondary"
                      v-clipboard:copy="systemBankSelected.accountNo"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      คัดลอก
                      <i class="fas fa-copy"></i>
                    </b-btn>
                  </div>
                </div>
              </b-card>
            </b-card>
          </b-col>
        </b-row>
        <b-row align-h="center" class="mt-3" v-if="systemBankSelected.length != 0">
          <b-col cols="12" md="8" lg="6">
            <b-card>
              <h5 class="mb-0">
                <b-badge pill variant="success" class="mr-2">Step 2</b-badge>
                <span class="text-secondary">โอนเงินเพื่อเติมเครดิต</span>
              </h5>
              <div v-if="!transfered">
                <b-btn
                  variant="primary"
                  type="button"
                  block
                  @click="transfered = true"
                  class="d-block d-sm-none mt-2"
                >เมื่อโอนเงินแล้ว คลิกที่นี่</b-btn>
                <b-alert
                  variant="danger"
                  show
                  class="mt-3"
                >โอนขั้นต่ำ "ครั้งละ 20 บาท" ถ้าโอนต่ำกว่า 20 บาทเงินของท่านจะไม่เข้าระบบ และไม่สามารถคืนได้</b-alert>
                <b-alert
                  variant="warning"
                  show
                  class="mt-2"
                >คำเตือน! กรุณาใช้บัญชีที่ท่านผูกกับ {{getAppName}} ในการโอนเงินเท่านั้น</b-alert>
                <b-alert variant="info" show class="mt-2">
                  เมื่อท่านทำการโอนเงินไปยังบัญชีข้างต้นเรียบร้อยแล้ว
                  <small>(เก็บสลิปการโอนไว้ทุกครั้ง)</small>
                  <br />
                  <strong>"คลิกปุ่มด้านล่าง"</strong>&nbsp;
                  <u>เพื่อแจ้งการโอนเงิน</u>
                </b-alert>
                <b-btn
                  variant="primary"
                  type="button"
                  class="d-none d-sm-block w-100"
                  @click="transfered = true"
                >เมื่อโอนเงินแล้ว คลิกที่นี่</b-btn>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row align-h="center" class="mt-3" v-if="transfered">
          <b-col cols="12" md="8" lg="6">
            <b-card>
              <h5>
                <b-badge pill variant="success" class="mr-2">Step 3</b-badge>
                <span class="text-secondary">แจ้งรายละเอียดการโอนเงิน</span>
              </h5>
              <b-alert variant="danger" show class="mt-2">กรุณาโอนเงินเข้าบัญชีด้านบน ภายใน 5 นาที</b-alert>
              <b-row>
                <b-col>
                  <label>
                    <i class="fas fa-university"></i>
                    เลือกบัญชีธนาคารของลูกค้า
                  </label>
                  <v-select
                    :options="userBanks"
                    v-model="userBankSelected"
                    placeholder="กรุณาเลือกธนาคาร"
                    @change="selectBank"
                    class="mb-2"
                  >
                    <template v-slot:selected-option="option">
                      <b-img
                        :src="banks[banks.map(e => e.bankID).indexOf(option.bankID)].logo"
                        height="22"
                        width="22"
                        class="mr-2 bank-icon"
                        :style="'background-color: ' + banks[banks.map(e => e.bankID).indexOf(option.bankID)].color"
                      />
                      <b-badge variant="light" class="mr-2">{{banks[banks.map(e => e.bankID).indexOf(option.bankID)].code}}</b-badge>
                      {{ option.accountNo }}
                    </template>
                    <template v-slot:option="option">
                      <b-img
                        :src="banks[banks.map(e => e.bankID).indexOf(option.bankID)].logo"
                        height="22"
                        width="22"
                        class="mr-2 bank-icon"
                        :style="'background-color: ' + banks[banks.map(e => e.bankID).indexOf(option.bankID)].color"
                      />
                      <b-badge variant="light" class="mr-2">{{banks[banks.map(e => e.bankID).indexOf(option.bankID)].code}}</b-badge>
                      {{ option.accountNo }}
                    </template>
                  </v-select>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <label>
                    <i class="fas fa-money-check-alt"></i>
                    เลือกช่องทางการโอนเงิน
                  </label>
                  <v-select
                    :options="paymentChannelMethods"
                    v-model="paymentChannelSelected"
                    placeholder="กรุณาเลือกช่องทางธุรกรรม"
                    @change="selectBank"
                    class="mb-2"
                  >
                    <template v-slot:selected-option="option">
                      <strong>{{ option.title }}</strong>
                    </template>
                    <template v-slot:option="option">
                      <strong>{{ option.title }}</strong>&nbsp;
                      <span class="text-secondary">
                        <small>{{ option.description }}</small>
                      </span>
                    </template>
                  </v-select>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <label>
                    <i class="fas fa-money-bill"></i>
                    จำนวนเงินที่โอน
                  </label>
                  <b-form-input type="number" min="1" v-model="transferAmount" @change="transferAmount = parseInt(transferAmount)" />
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col>
                  <label>
                    <i class="fas fa-calendar"></i>
                    วันที่โอน
                  </label>
                  <b-form-input type="date" v-model="transferDate" />
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col>
                  <label>
                    <i class="far fa-clock"></i>
                    เวลาที่โอน
                    <b-button
                      class="btn-orange btn btn-sm mr-1 px-1 py-0 btn-warning"
                      v-b-modal.ex-deposit
                    >
                      ตัวอย่าง: การแจ้งฝาก คลิก
                      <i class="fas fa-hand-pointer"></i>
                    </b-button>
                  </label>
                  <!-- <b-form-input type="time" v-model="transferTime" /> -->
                  <b-time v-model="transferTime" locale="th"></b-time>
                  <small
                    class="warning mt-2"
                    style="display: inline-block; line-height: 1.2;"
                  >* กรุณากรอก วัน-เวลา ในการโอนให้ตรงกับ Slip ระบบจะเติมเครดิตให้คุณอัตโนมัติ</small>
                </b-col>
              </b-row>
              <b-modal
                id="ex-deposit"
                title="ตัวอย่างการแจ้งฝากเงิน"
                size="lg"
                header-bg-variant="dark"
                header-text-variant="white"
              >
                <img :src="require('../../assets/images/deposit.jpg')" class="w-100" />
                <template #modal-footer>
                  <div class="w-100">
                    <b-button variant="dark" class="float-right" @click="$bvModal.hide('ex-deposit')">ปิด</b-button>
                  </div>
                </template>
              </b-modal>
              <b-row class="mt-2">
                <b-col>
                  <label>
                    <i class="far fa-star"></i>
                    หมายเหตุ
                  </label>
                  <b-form-textarea v-model="description" />
                  <small>
                    กรุณาตรวจสอบข้อมูลของท่านให้ถูกต้อง และกดปุ่ม
                    <span
                      class="text-success"
                    >ยืนยันการแจ้งโอนเงิน</span>
                  </small>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col>
                  <b-button
                    variant="success"
                    :disabled="userBankSelected.length == 0 || paymentChannelSelected.length == 0 || transferAmount === null || transferAmount == '' || transferAmount <= 0 ? 'disabled' : false"
                    block
                    @click="addCashTransfer()"
                  >
                    ยืนยันการแจ้งโอนเงิน
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>
// Include Component
import TopBarMember from "@/components/TopBarMember.vue";
import FooterIndex from "@/components/Footer.vue";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: 'Deposit',
  props: ['page'],
  components: {
    TopBarMember,
    FooterIndex
  },
  data() {
    return {
      systemBankSelected: [],
      paymentChannelSelected: [],
      paymentChannelMethods: [
        {
          value: 1,
          title: "ATM",
          description: "โอนจากตู้กดเงินสด"
        },
        {
          value: 2,
          title: "CDM",
          description: "ฝากผ่านตู้ฝากเงินสด"
        },
        {
          value: 3,
          title: "Counter Cashier",
          description: "ฝากเงินผ่านเคาน์เตอร์ธนาคาร"
        },
        {
          value: 4,
          title: "Internet Banking",
          description: "โอนเงินผ่านหน้าเว็บไซต์"
        },
        {
          value: 5,
          title: "Mobile Banking",
          description: "โอนเงินผ่านแอพมือถือ"
        }
      ],
      userBankSelected: [],
      transfered: false,
      banks: [
        {
          bankID: 1,
          code: "BBL",
          title: "กรุงเทพ",
          logo: require('../../assets/images/bank-icon/bbl.svg'),
          color: "#1e4598"
        },
        {
          bankID: 2,
          code: "KBANK",
          title: "กสิกรไทย",
          logo: require('../../assets/images/bank-icon/kbank.svg'),
          color: "#138f2d"
        },
        {
          bankID: 3,
          code: "KTB",
          title: "กรุงไทย",
          logo: require('../../assets/images/bank-icon/ktb.svg'),
          color: "#1ba5e1"
        },
        {
          bankID: 4,
          code: "SCB",
          title: "ไทยพาณิชย์",
          logo: require('../../assets/images/bank-icon/scb.svg'),
          color: "#4e2e7f"
        },
        {
          bankID: 5,
          code: "BAY",
          title: "กรุงศรีอยุธยา",
          logo: require('../../assets/images/bank-icon/bay.svg'),
          color: "#fec43b"
        },
        {
          bankID: 6,
          code: "CIMB",
          title: "ซีไอเอ็มบี",
          logo: require('../../assets/images/bank-icon/cimb.svg'),
          color: "#7e2f36"
        },
        {
          bankID: 7,
          code: "GSB",
          title: "ออมสิน",
          logo: require('../../assets/images/bank-icon/gsb.svg'),
          color: "#eb198d"
        },
        {
          bankID: 8,
          code: "KIATNAKIN",
          title: "เกียรตินาคิน",
          logo: require('../../assets/images/bank-icon/kk.svg'),
          color: "#199cc5"
        },
        {
          bankID: 9,
          code: "LHBANK",
          title: "แลนด์ แอนด์ เฮาส์",
          logo: require('../../assets/images/bank-icon/lhb.svg'),
          color: "#6d6e71"
        },
        {
          bankID: 10,
          code: "STANDARD",
          title: "สแตนดาร์ดชาร์เตอร์ด (ไทย)",
          logo: require('../../assets/images/bank-icon/sc.svg'),
          color: "#0f6ea1"
        },
        {
          bankID: 11,
          code: "THANACHART",
          title: "ธนชาติ",
          logo: require('../../assets/images/bank-icon/tbnk.svg'),
          color: "#fc4f1f"
        },
        {
          bankID: 12,
          code: "TISCO",
          title: "ทิสโก้",
          logo: require('../../assets/images/bank-icon/tisco.svg'),
          color: "#12549f"
        },
        {
          bankID: 13,
          code: "TMB",
          title: "ทหารไทย",
          logo: require('../../assets/images/bank-icon/tmb.svg'),
          color: "#1279be"
        },
        {
          bankID: 14,
          code: "UOB",
          title: "ยูโอบี",
          logo: require('../../assets/images/bank-icon/uob.svg'),
          color: "#0b3979"
        }
      ],
      systemBanks: [],
      userBanks: [],
      transferAmount: 100,
      transferDate: null,
      transferTime: null,
      description: null
    };
  },
  mounted() {
    this.getSystemBank();
    this.getUserBank();
    this.transferDate = moment().format("YYYY-MM-DD");
    this.transferTime = moment().format("HH:mm");
  },
  methods: {
    selectBank() {
      this.transfered = false;
    },
    onCopy(e) {
      this.$bvToast.toast("คัดลอกเลขที่บัญชีเรียบร้อยแล้ว", {
        title: `สำเร็จ`,
        variant: "success",
        //solid: true,
        autoHideDelay: 3000
      });
    },
    addCashTransfer() {
      console.log('submitted');
      axios.post(this.getApiUrl + "/cash/addcashtransfer",
        {
          username: this.getUsername,
          transferType: 1,
          transferDate: moment(this.transferDate + ' ' + this.transferTime).format('YYYY-MM-DD HH:mm:ss'),
          amount: this.transferAmount,
          bankAccountID: this.userBankSelected.id,
          systemBankAccountID: this.systemBankSelected.id,
          channel: this.paymentChannelSelected.value,
          detail: this.description
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        } )
        .then(response => {
          // this.systemBanks = response.data.data;
          this.$router.push("/member/transaction");
          console.log(response);
        });
    },
    getSystemBank() {
      axios.post(this.getApiUrl + "/cash/getallSystemBankAccount",
        {
          username: this.getUsername,
          numberSetName: this.numberSetName,
          NumberSets: this.items
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        } )
        .then(response => {
          this.systemBanks = response.data.data;
          console.log(response);
        });
    },
    getUserBank() {
      axios.post(this.getApiUrl + "/cash/getallBankAccount",
        {
          username: this.getUsername
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        } )
        .then(response => {
          this.userBanks = response.data.data;
          console.log(response);
        });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl",
      getAppName: "getAppName"
    })
  }
}
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.warning {
  color: #bd841b;
}

.bank-icon {
  padding: 3px;
}

.bank-logo {
  padding: 10px;
}

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.button {
  &-warning {
    background-color: #bd841b;
    border-color: #bd841b;
    color: #ffffff;
  }

  &-outline-warning {
    color: #bd841b;
    border-color: #bd841b;
  }

  &:hover,
  &:focus,
  &:active {
    background-color: #bd841b;
    border-color: #bd841b;
    outline: none;
    box-shadow: none;
    color: #ffffff;
  }
}

.btn-orange {
  text-transform: uppercase;
  color: #fff;
  background-color: #fd7e14;
  padding: 1.2em;
  width: auto;
  box-shadow: 0 3px 3px rgb(0 0 0 / 35%);
  /* font-size: 1.2em; */
  text-align: center;
  margin: 0;
  text-decoration: none;
  position: relative;
  overflow: hidden;
}
</style>